<template>
	<div>
		<sub-header bizCd="02"/>
		<div class="sub_visual sub04">
			<div class="container">
				<div class="sub_txt">
					<div class="tit">집합 교육</div>
					<div class="comment">맞춤형 면대면(Face to Face) 교육의 노하우<br>
						현장감 있는 강의를 통해 학습 효과를 극대화하세요.</div>
				</div>
			</div>
		</div>
		<div class="contents aos-all">
			<div class="container">
				<div class="sec">
					<div class="sub_tit">교육과정</div>
					<div class="con">
						<div class="txt">지금 가장 뜨겁게 부상중인 기업별 선호과정을 확인하세요.</div>
						<div class="course_list">
							<div class="course_box">
								<div class="p_wrap">
									<div class="co_tit">
										<div class="icon">
											<img src="//img.eduwill.net/resources/b2b/dev/images/01-icon-license.png" alt="전문 직무" class="pc840hidden"/>
											<img src="//img.eduwill.net/resources/b2b/dev/images/icon-license@3x.png" alt="전문 직무" class="mobile840hidden"/>
										</div>
										<div class="txt">전문 직무</div>
									</div>
									<div class="co_contents">
										<ul class="co_list">
											<li>・ 부동산</li>
											<li>・ 산업안전보건</li>
											<li>・ 유통 /물류</li>
											<li>・ 블록체인 전문가</li>
											<li>・ 재무/회계</li>
											<li>・ 증권 전문가</li>
										</ul>
									</div>
								</div>
							</div>
		
							<div class="course_box">
								<div class="p_wrap">
									<div class="co_tit">
										<div class="icon">
											<img src="//img.eduwill.net/resources/b2b/dev/images/01-icon-advice.png" alt="자소서/면접" class="pc840hidden"/>
											<img src="//img.eduwill.net/resources/b2b/dev/images/icon-advice@3x.png" alt="자소서/면접" class="mobile840hidden"/>
										</div>
										<div class="txt">자소서/면접</div>
									</div>
									<div class="co_contents">
										<ul class="co_list wide">
											<li>・ 공기업 자소서</li>
											<li>・ 대기업 자소서</li>
											<li>・ 면접 컨설팅</li>
		
										</ul>
									</div>
								</div>
							</div>
		
							<div class="course_box">
								<div class="p_wrap">
									<div class="co_tit">
										<div class="icon">
											<img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-ncs.png" alt="NCS" class="pc840hidden"/>
											<img src="//img.eduwill.net/resources/b2b/dev/images/icon-ncs@3x.png" alt="NCS" class="mobile840hidden"/>
										</div>
										<div class="txt">NCS</div>
									</div>
									<div class="co_contents">
										<ul class="co_list">
											<li>・ 수리 영역</li>
											<li>・ 대인관계 능력</li>
											<li>・ 비수리 영역</li>
											<li>・ 자기개발 능력</li>
											<li>・ 의사소통 능력</li>
											<li>・ 자원관리 능력</li>
											<li>・ 조직이해 능력</li>
										</ul>
									</div>
								</div>
							</div>
		
							<div class="course_box h230">
								<div class="p_wrap">
									<div class="co_tit">
										<div class="icon">
											<img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-suitcase.png" alt="대기업" class="pc840hidden"/>
											<img src="//img.eduwill.net/resources/b2b/dev/images/icon-suitcase@3x.png" alt="대기업" class="mobile840hidden"/>
										</div>
										<div class="txt">대기업</div>
									</div>
									<div class="co_contents">
										<ul class="co_list wide">
											<li>・ 대기업 직무적성검사</li>
											<li>・ 삼성 GSAT 특강</li>
											<li>・ SK그룹 SKCT 특강</li>
											<li>・ 롯데그룹 L-TAB 특강</li>
											<li>・ LG그룹 특강</li>
											<li>・ CJ그룹 특강</li>
										</ul>
									</div>
								</div>
							</div>
		
							<div class="course_box h230">
								<div class="p_wrap">
									<div class="co_tit">
										<div class="icon">
											<img src="//img.eduwill.net/resources/b2b/dev/images/icon-civil.png" alt="공무원" class="pc840hidden"/>
											<img src="//img.eduwill.net/resources/b2b/dev/images/icon-civil@3x.png" alt="공무원" class="mobile840hidden"/>
										</div>
										<div class="txt">공무원</div>
									</div>
									<div class="co_contents">
										<ul class="co_list wide">
											<li>・ 필수과목 특강</li>
											<li>・ 공무원 면접 특강</li>
											<li>・ PSAT 특강</li>
										</ul>
									</div>
								</div>
							</div>
		
							<div class="course_box h230">
								<div class="p_wrap">
									<div class="co_tit">
										<div class="icon">
											<img src="//img.eduwill.net/resources/b2b/dev/images/icon-job.png" alt="재취업/전직지원연계교육" class="pc840hidden"/>
											<img src="//img.eduwill.net/resources/b2b/dev/images/icon-job@3x.png" alt="재취업/전직지원연계교육" class="mobile840hidden"/>
										</div>
										<div class="txt line02"><p class="mx160">재취업/전직지원 연계교육</p></div>
									</div>
									<div class="co_contents">
										<ul class="co_list wide">
											<li>・ 부동산/시설관리 전문가</li>
											<li>・ 시니어 컨설팅 전문가</li>
											<li>・ 반려견 전문가</li>
											<li>・ HRD관련</li>
											<li>・ 생애설계</li>
											<li>・ 여가/재무</li>
										</ul>
										<div class="c_text">*해당 과정은 외부교육사 과정과 연계하여 진행됩니다.</div>
									</div>
								</div>
							</div>
						</div>
						
					</div>
				</div>
				<div class="sec">
					<div class="sub_tit">집합 교육 영상</div>
					<div class="con">
						<div class="txt txt_line2">30여 년의 교육 노하우를 바탕으로 맞춤형 면대면(Face to Face) 강의를 제공합니다.<br>생생한 현장 강의와 학습상담을 통해 학습 효과를 극대화할 수 있습니다.</div>
						<div class="video_wrap">
		
							<div class="control-box blind" onclick="$(this).hide().next('.video_play').show().find('video').get(0).play();">
								<img src="//img.eduwill.net/resources/b2b/dev/images/mask_2_1.png">
								<div class="btn_play"><img src="//img.eduwill.net/resources/b2b/dev/images/play-button.png"></div>
							</div>
							<div class="video_play" style="display: none;">
								<video src="//img.eduwill.net/resources/b2b/dev/video/ZA4-YSH-SAMPLE-2.mp4" controls=""></video>
							</div>
						</div>
					</div>
				</div>
				<div class="sec">
					<div class="sub_tit">청년 취업지원<br class="m_hidden">위탁 교육</div>
					<div class="con">
						<div class="txt txt_line2">정부 산하 기관 및 지방자치단체에서 주관하는 청년 취업지원 온·오프라인 교육을 위탁 운영합니다.<br>최적화된 교육 컨설팅을 통해 취업 성공 및 커리어 개발에 도움을 드리겠습니다.</div>
						<div class="partnership_wrap">
							<div class="pa_img"><img src="//img.eduwill.net/resources/b2b/dev/images/02_01_edu_1.png" alt="특별이벤트"></div>
							<div class="pa_img"><img src="//img.eduwill.net/resources/b2b/dev/images/02_01_edu_2.png" alt="특별이벤트"></div>
						</div>
					</div>
				</div>
				<div class="sec">
					<div class="clearfix">
						<div class="sub_tit">집합교육 Flow</div>
					</div>
					<div class="con_wide">
						<!-- flow PC -->
						<div class="flow_common flow_m_hidden">
							<div class="f_wrap">
								<div class="step01 aos-item" data-aos="fade-right" data-aos-delay="300" data-aos-offset="0"><img src="//img.eduwill.net/resources/b2b/dev/images/img-flow-02-01-01.png" alt="고객사"/></div>
								<div class="step02 flow_line aos-item" data-aos="fade-right" data-aos-delay="450" data-aos-offset="0">
									<div class="text">과정 문의, 요구사항 전달</div>
									<div class="arrow_right"><img src="//img.eduwill.net/resources/b2b/dev/images/path-5.png" alt="flow화살표"/></div>
									<div class="arrrow_left"><img src="//img.eduwill.net/resources/b2b/dev/images/path-5-copy.png" alt="flow화살표"/></div>
									<div class="text">과정 관리, 운영 보고</div>
								</div>
								<div class="step03 aos-item" data-aos="fade-right" data-aos-delay="600" data-aos-offset="0">
									<div class="step_edu">
										<div class="step_edu_con">
											<img src="//img.eduwill.net/resources/b2b/dev/images/logo_on.png"/>
											<p>에듀윌</p>
										</div>
									</div>
									<div class="step_text">강사, 교육장 섭외 및 교육 진행</div>
								</div>
								<div class="step04 flow_line aos-item" data-aos="fade-right" data-aos-delay="750" data-aos-offset="0">
									<div class="text">학습지원</div>
									<div class="arrow_right"><img src="//img.eduwill.net/resources/b2b/dev/images/path-5.png" alt="flow화살표"/></div>
									<div class="arrrow_left"><img src="//img.eduwill.net/resources/b2b/dev/images/path-5-copy.png" alt="flow화살표"/></div>
									<div class="text">강좌 수강, 학습 문의</div>
								</div>
								<div class="step05 aos-item" data-aos="fade-right" data-aos-delay="900" data-aos-offset="0"><img src="//img.eduwill.net/resources/b2b/dev/images/img-flow-02-01-03.png" alt="수강생"/></div>
							</div>
						</div>
		
						<!-- flow Mobile  -->
						<div class="flow_common flow_pc_hidden">
							<div class="f_wrap">
								<div class="wide">
									<div class="step_edu aos-item" data-aos="fade-right" data-aos-delay="450" data-aos-offset="0">
										<div class="step_edu_con">
											<img src="//img.eduwill.net/resources/b2b/dev/images/logo_on.png"/>
											<p>에듀윌</p>
										</div>
									</div>
									<div class="step_text">강사, 교육장 섭외 및 교육 진행</div>
								</div>
								<div class="stepper">
									<div class="img_left aos-item" data-aos="fade-right" data-aos-delay="300" data-aos-offset="0">
										<div class="flow_mo_left">
											<img src="//img.eduwill.net/resources/b2b/dev/images/flow02_1_left.png"/>
										</div>
									</div>
									<div class="img_right aos-item" data-aos="fade-right" data-aos-delay="600" data-aos-offset="0">
										<div class="flow_mo_right">
											<img src="//img.eduwill.net/resources/b2b/dev/images/flow02_1_right.png"/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	<div class="float_counsel m_hidden">
        <div class="group-wrap">
            <div class="group">
                <div class="text">에듀윌과 함께<br>변화를 시작하세요.</div>
                <div class="button" @click="showCounsel('01')"><a href="javascript:;" @click="show_counsel('01')">맞춤상담신청</a></div>
                <div class="ico-hand"></div>
            </div>
        </div>
    </div>
    <div class="float_counsel_mobile pc_hidden">
		<a class="circle_counsel" @click="showCounsel('01')">맞춤<br>상담</a>
    </div>
	</div>
</template>

<script>
import SubHeader from "@/layouts/SubHeader";
import eventBus from "@/eventBus/event-bus";

export default {
	name: "MainZoomEdu",
	components: {SubHeader},
	data() {
		return {}
	},
	
	computed: {
	},
	
	methods: {
		showCounsel(v) {
			eventBus.$emit("show-counsel", v);
		},
		closeCurriculum(v) {
			$('.curriculum_pop_' + v).bPopup().close();
		},
		showCurriculum(v) {
			$('.curriculum_pop_' + v).bPopup();
		}
	},
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
	},
}
</script>

<style scoped>

</style>
